<!--
  -  Copyright (c) Qwoach LLC 2021. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 16/12/2021
  -->

<script>

import BaseComponent from "@/core/components/BaseComponent.vue";
import CyEditor from "@/core/recoveryCoachingApp/coach/clients/ClientDetails/Genogram/GenogramEditor/lib";

export default {
	name: "CyPropWatchingView",
	extends: BaseComponent,
	props: {
		cyEditor: {CyEditor, required: true},
	},
	watch: {
		cyEditor: {
			immediate: true,
			handler() {
				console.log("ElementDetailsPanel: this.cy = ", this.cy)
				if (this.cyEditor) {
					this.cy = this.cyEditor.cy
					this.onCyReady()
				}

			}
		}
	},

	methods: {
		onCyReady() {

		}
	},

}
</script>

<style lang="scss">

</style>
